import React from "react";
import TableText from "../../TableText";

export const columns1 = (print) => {
    return [{
        title: <div>Key Performance Indicator <br /> 餐饮关键绩效指数</div>,
        dataIndex: 'name',
        key: 'name',
        align: "center",
        width: 200,
        fixed: print ? false : "left",
        render: (text, record, index) => {
            const props = {
                text, index, type: 'text', name: "name",

            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&Brevenue <br /> 餐饮收入</div>,
        dataIndex: 'fb',
        key: 'fb',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "fb",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&B Revenue/ Total Revenue % <br /> 餐饮收入占酒店总收入%</div>,
        dataIndex: 'fb_prop',
        key: 'fb_prop',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_prop",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>A/C <br /> 人均消费</div>,
        dataIndex: 'ac',
        key: 'ac',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "ac",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>Covers <br /> 用餐总人数</div>,
        dataIndex: 'covers',
        key: 'covers',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "covers",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&B Dep't Profit % <br />  餐饮部门利润率</div>,
        dataIndex: 'fb_profit',
        key: 'fb_profit',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_profit",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&B Total Payroll and Expenses <br /> 餐饮部门薪酬及相关福利合计%</div>,
        dataIndex: 'fb_payroll',
        key: 'fb_payroll',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_payroll",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>Total Cost of Food and Beverage Sales % <br /> 餐饮成本占部门收入百分比</div>,
        dataIndex: 'fb_sales',
        key: 'fb_sales',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_sales",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&Brevenue <br /> 餐饮收入</div>,
        dataIndex: 'fb_last',
        key: 'fb_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "fb_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'fb_vs',
        key: 'fb_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "fb_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&B Revenue/ Total Revenue % <br /> 餐饮收入占酒店总收入%</div>,
        dataIndex: 'fb_prop_last',
        key: 'fb_prop_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_prop_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'fb_prop_vs',
        key: 'fb_prop_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "fb_prop_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>A/C <br /> 人均消费</div>,
        dataIndex: 'ac_last',
        key: 'ac_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "ac_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'ac_vs',
        key: 'ac_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "ac_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Covers 用餐总人数",
        dataIndex: 'covers_last',
        key: 'covers_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "covers_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'covers_vs',
        key: 'covers_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "covers_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&B Dep't Profit % <br />餐饮部门利润率</div>,
        dataIndex: 'fb_profit_last',
        key: 'fb_profit_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_profit_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'fb_profit_vs',
        key: 'fb_profit_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_profit_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>F&B Total Payroll and Expenses <br /> 餐饮部门薪酬及相关福利合计%</div>,
        dataIndex: 'fb_payroll_last',
        key: 'fb_payroll_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_payroll_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'fb_payroll_vs',
        key: 'fb_payroll_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_payroll_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: <div>Total Cost of Food and Beverage Sales % <br /> 餐饮成本占部门收入百分比</div>,
        dataIndex: 'fb_sales_last',
        key: 'fb_sales_last',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_sales_last",
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Vs2019/预算",
        dataIndex: 'fb_sales_vs',
        key: 'fb_sales_vs',
        align: "center",
        width: 150,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'percent', name: "fb_sales_vs",
            };
            return <TableText data={{ ...props }} />
        }
    }];
}


export const columns2 = () => {
    return [
        {
            title: <div>Banquet Revenue <br />  宴会收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "rev",
                    totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 5
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual年累计实际" : 'MTD-Actual月累计实际'
                        }} />
                    }
                }
                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Revenue Mix <br />  收入份额% </div>,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'ac',
            key: 'ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% <br></br>成本百分比</div>,
            dataIndex: 'cost',
            key: 'cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Banquet Revenue <br></br>宴会收入</div>,
            dataIndex: 'brev',
            key: 'brev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "brev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.Budget 年累计-实际对比预算" : 'MTD-Actual Vs.Budget 年累计-实际对比预算'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'vs',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix<br></br>收入份额%</div>,
            dataIndex: 'bmix',
            key: 'bmix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bvs',
            key: 'bvs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bvs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'bac',
            key: 'bac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bac_vs',
            key: 'bac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'bcost',
            key: 'bcost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcost_vs',
            key: 'bcost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'bcovers',
            key: 'bcovers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcovers_vs',
            key: 'bcovers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Banquet Revenue <br></br> 宴会收入</div>,
            dataIndex: 'last_rev',
            key: 'last_rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_rev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.2019 年累计-实际对比2019" : 'MTD-Actual Vs.2019 年累计-实际对比2019'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_vs',
            key: 'last_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix <br></br> 收入份额%</div>,
            dataIndex: 'last_mix',
            key: 'last_mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_mix_vs',
            key: 'last_mix_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'last_ac',
            key: 'last_ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_ac_vs',
            key: 'last_ac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'last_cost',
            key: 'last_cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_cost_vs',
            key: 'last_cost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'last_covers',
            key: 'last_covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_covers_vs',
            key: 'last_covers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }
    ]
}

export const columns3 = () => {
    return [
        {
            title: <div>Coffee Shop Revenue <br></br> 咖啡厅收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "rev",
                    totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 5
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual年累计实际" : 'MTD-Actual月累计实际'
                        }} />
                    }
                }
                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Revenue Mix <br />  收入份额% </div>,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'ac',
            key: 'ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% <br></br>成本百分比</div>,
            dataIndex: 'cost',
            key: 'cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Coffee Shop Revenue <br></br> 咖啡厅收入</div>,
            dataIndex: 'brev',
            key: 'brev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "brev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.Budget 年累计-实际对比预算" : 'MTD-Actual Vs.Budget 年累计-实际对比预算'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'vs',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix<br></br>收入份额%</div>,
            dataIndex: 'bmix',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bvs',
            key: 'bvs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bvs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'bac',
            key: 'bac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bac_vs',
            key: 'bac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'bcost',
            key: 'bcost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcost_vs',
            key: 'bcost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'bcovers',
            key: 'bcovers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcovers_vs',
            key: 'bcovers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Coffee Shop Revenue <br></br> 咖啡厅收入</div>,
            dataIndex: 'last_rev',
            key: 'last_rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_rev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.2019 年累计-实际对比2019" : 'MTD-Actual Vs.2019 年累计-实际对比2019'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_vs',
            key: 'last_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix <br></br> 收入份额%</div>,
            dataIndex: 'last_mix',
            key: 'last_mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_mix_vs',
            key: 'last_mix_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'last_ac',
            key: 'last_ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_ac_vs',
            key: 'last_ac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'last_cost',
            key: 'last_cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_cost_vs',
            key: 'last_cost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'last_covers',
            key: 'last_covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_covers_vs',
            key: 'last_covers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }
    ]
}

export const columns4 = () => {
    return [
        {
            title: <div>Chinese RestaurantRevenue <br></br>中餐厅收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "rev",
                    totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 5
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual年累计实际" : 'MTD-Actual月累计实际'
                        }} />
                    }
                }
                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Revenue Mix <br />  收入份额% </div>,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'ac',
            key: 'ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% <br></br>成本百分比</div>,
            dataIndex: 'cost',
            key: 'cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Chinese RestaurantRevenue <br></br>中餐厅收入</div>,
            dataIndex: 'brev',
            key: 'brev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "brev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.Budget 年累计-实际对比预算" : 'MTD-Actual Vs.Budget 年累计-实际对比预算'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'vs',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix<br></br>收入份额%</div>,
            dataIndex: 'bmix',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bvs',
            key: 'bvs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bvs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'bac',
            key: 'bac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bac_vs',
            key: 'bac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'bcost',
            key: 'bcost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcost_vs',
            key: 'bcost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'bcovers',
            key: 'bcovers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcovers_vs',
            key: 'bcovers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Chinese RestaurantRevenue <br></br>中餐厅收入</div>,
            dataIndex: 'last_rev',
            key: 'last_rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_rev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.2019 年累计-实际对比2019" : 'MTD-Actual Vs.2019 年累计-实际对比2019'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_vs',
            key: 'last_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix <br></br> 收入份额%</div>,
            dataIndex: 'last_mix',
            key: 'last_mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_mix_vs',
            key: 'last_mix_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'last_ac',
            key: 'last_ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_ac_vs',
            key: 'last_ac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'last_cost',
            key: 'last_cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_cost_vs',
            key: 'last_cost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'last_covers',
            key: 'last_covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_covers_vs',
            key: 'last_covers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }
    ]
}


export const columns5 = () => {
    return [
        {
            title: <div> Special Restaurant Revenue <br></br> 特色餐厅收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "rev",
                    totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 5
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual年累计实际" : 'MTD-Actual月累计实际'
                        }} />
                    }
                }
                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Revenue Mix <br />  收入份额% </div>,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'ac',
            key: 'ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% <br></br>成本百分比</div>,
            dataIndex: 'cost',
            key: 'cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div> Special Restaurant Revenue <br></br> 特色餐厅收入</div>,
            dataIndex: 'brev',
            key: 'brev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "brev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.Budget 年累计-实际对比预算" : 'MTD-Actual Vs.Budget 年累计-实际对比预算'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'vs',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix<br></br>收入份额%</div>,
            dataIndex: 'bmix',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bvs',
            key: 'bvs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bvs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'bac',
            key: 'bac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bac_vs',
            key: 'bac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'bcost',
            key: 'bcost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcost_vs',
            key: 'bcost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'bcovers',
            key: 'bcovers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcovers_vs',
            key: 'bcovers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div> Special Restaurant Revenue <br></br> 特色餐厅收入</div>,
            dataIndex: 'last_rev',
            key: 'last_rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_rev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.2019 年累计-实际对比2019" : 'MTD-Actual Vs.2019 年累计-实际对比2019'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_vs',
            key: 'last_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix <br></br> 收入份额%</div>,
            dataIndex: 'last_mix',
            key: 'last_mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_mix_vs',
            key: 'last_mix_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'last_ac',
            key: 'last_ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_ac_vs',
            key: 'last_ac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'last_cost',
            key: 'last_cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_cost_vs',
            key: 'last_cost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'last_covers',
            key: 'last_covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_covers_vs',
            key: 'last_covers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }
    ]
}


export const columns6 = () => {
    return [
        {
            title: <div>Lobby Bar Revenue <br></br> 大堂吧收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "rev",
                    totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 5
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual年累计实际" : 'MTD-Actual月累计实际'
                        }} />
                    }
                }
                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Revenue Mix <br />  收入份额% </div>,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'ac',
            key: 'ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% <br></br>成本百分比</div>,
            dataIndex: 'cost',
            key: 'cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Lobby Bar Revenue <br></br> 大堂吧收入</div>,
            dataIndex: 'brev',
            key: 'brev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "brev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.Budget 年累计-实际对比预算" : 'MTD-Actual Vs.Budget 年累计-实际对比预算'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'vs',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix<br></br>收入份额%</div>,
            dataIndex: 'bmix',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bvs',
            key: 'bvs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bvs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'bac',
            key: 'bac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bac_vs',
            key: 'bac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'bcost',
            key: 'bcost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcost_vs',
            key: 'bcost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'bcovers',
            key: 'bcovers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcovers_vs',
            key: 'bcovers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Lobby Bar Revenue <br></br> 大堂吧收入</div>,
            dataIndex: 'last_rev',
            key: 'last_rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_rev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.2019 年累计-实际对比2019" : 'MTD-Actual Vs.2019 年累计-实际对比2019'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_vs',
            key: 'last_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix <br></br> 收入份额%</div>,
            dataIndex: 'last_mix',
            key: 'last_mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_mix_vs',
            key: 'last_mix_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'last_ac',
            key: 'last_ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_ac_vs',
            key: 'last_ac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'last_cost',
            key: 'last_cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_cost_vs',
            key: 'last_cost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'last_covers',
            key: 'last_covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_covers_vs',
            key: 'last_covers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }
    ]
}


export const columns7 = () => {
    return [
        {
            title: <div>Room Service Revenue <br></br> 客房送餐收入</div>,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "rev",
                    totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 5
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual年累计实际" : 'MTD-Actual月累计实际'
                        }} />
                    }
                }
                return <TableText data={{
                    ...props
                }} />
            }
        }, {
            title: <div>Revenue Mix <br />  收入份额% </div>,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'ac',
            key: 'ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% <br></br>成本百分比</div>,
            dataIndex: 'cost',
            key: 'cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Room Service Revenue <br></br> 客房送餐收入</div>,
            dataIndex: 'brev',
            key: 'brev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "brev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.Budget 年累计-实际对比预算" : 'MTD-Actual Vs.Budget 年累计-实际对比预算'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'vs',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix<br></br>收入份额%</div>,
            dataIndex: 'bmix',
            key: 'vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bvs',
            key: 'bvs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bvs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'bac',
            key: 'bac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bac_vs',
            key: 'bac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'bcost',
            key: 'bcost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcost_vs',
            key: 'bcost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "bcost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'bcovers',
            key: 'bcovers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs Budget</div>,
            dataIndex: 'bcovers_vs',
            key: 'bcovers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "bcovers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Room Service Revenue <br></br> 客房送餐收入</div>,
            dataIndex: 'last_rev',
            key: 'last_rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_rev", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) {
                    return {
                        props: {
                            colSpan: 10
                        },
                        children: <TableText data={{
                            ...props,
                            type: "textcenter",
                            text: index == 0 ? "YTD-Actual Vs.2019 年累计-实际对比2019" : 'MTD-Actual Vs.2019 年累计-实际对比2019'
                        }} />
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_vs',
            key: 'last_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Revenue Mix <br></br> 收入份额%</div>,
            dataIndex: 'last_mix',
            key: 'last_mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_mix_vs',
            key: 'last_mix_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_mix_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'last_ac',
            key: 'last_ac',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_ac_vs',
            key: 'last_ac_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_ac_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Cost% 成本百分比</div>,
            dataIndex: 'last_cost',
            key: 'last_cost',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_cost_vs',
            key: 'last_cost_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'percent', name: "last_cost_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Covers 用餐人数</div>,
            dataIndex: 'last_covers',
            key: 'last_covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Vs 2019</div>,
            dataIndex: 'last_covers_vs',
            key: 'last_covers_vs',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "last_covers_vs", totalIndex: [0, 2]
                };
                if (index == 0 || index == 2) return {
                    props: {
                        colSpan: 0
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }
    ]
}

export const columns8 = (print) => {
    return [{
        title: <div>Key Performance Indicator <br></br> 关键数据</div>,
        dataIndex: 'name',
        key: 'name',
        align: "center",
        width: 150,
        fixed: print ? false : 'left',
        render: (text, record, index) => {
            const props = {
                text, index, type: 'text', name: "name"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Jan 一月",
        dataIndex: 'jan',
        key: 'jan',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "jan"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Feb 二月",
        dataIndex: 'feb',
        key: 'feb',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "feb"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Mar 三月",
        dataIndex: 'mar',
        key: 'mar',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "mar"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Apr 四月",
        dataIndex: 'apr',
        key: 'apr',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "apr"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "May 五月",
        dataIndex: 'may',
        key: 'may',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "may"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Jun 六月",
        dataIndex: 'jun',
        key: 'jun',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "jun"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Jul 七月",
        dataIndex: 'jul',
        key: 'jul',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "jul"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Aug 八月",
        dataIndex: 'aug',
        key: 'aug',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "aug"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Sep 九月",
        dataIndex: 'sep',
        key: 'sep',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "sep"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Oct 十月",
        dataIndex: 'oct',
        key: 'oct',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "oct"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Nov 十一月",
        dataIndex: 'nov',
        key: 'nov',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "nov"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Dec 十二月",
        dataIndex: 'dec',
        key: 'dec',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "dec"
            };
            return <TableText data={{ ...props }} />
        }
    }, {
        title: "Whole Year Budget全年预算",
        dataIndex: 'budget',
        key: 'budget',
        align: "center",
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "budget"
            };
            if (index == 0) {
                return {
                    props: {
                        rowSpan: 2
                    },
                    children: <TableText data={{ ...props }} />
                }
            }
            return {
                props: {
                    rowSpan: 0
                }
            }
        }
    }, {
        title: "Whole Year Forecast全年预测",
        dataIndex: 'forecast',
        key: 'forecast',
        align: "center",
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "forecast"
            };
            if (index == 0) {
                return {
                    props: {
                        rowSpan: 2
                    },
                    children: <TableText data={{ ...props }} />
                }
            }
            return {
                props: {
                    rowSpan: 0
                }
            }
        }
    }, {
        title: "YTD-Actual 年累计实际",
        dataIndex: 'actual',
        key: 'actual',
        align: "center",
        render: (text, record, index) => {
            const props = {
                text, index, type: 'number', name: "actual"
            };
            if (index == 0) {
                return {
                    props: {
                        rowSpan: 2
                    },
                    children: <TableText data={{ ...props }} />
                }
            }
            return {
                props: {
                    rowSpan: 0
                }
            }
        }
    }]
}

export const data1 = [{
    sort: 0,
    name: "YTD-Actual Vs. 2019 <br /> 年累计-实际对比2019",
    fb: "",
    fb_prop: "",
    ac: "",
    covers: "",
    fb_profit: "",
    fb_payroll: "",
    fb_sales: "",
    fb_last: "",
    fb_vs: "",
    fb_prop_last: "",
    fb_prop_vs: "",
    ac_last: "",
    ac_vs: "",
    covers_last: "",
    covers_vs: "",
    fb_profit_last: "",
    fb_profit_vs: "",
    fb_payroll_last: "",
    fb_payroll_vs: "",
    fb_sales_last: "",
    fb_sales_vs: ""
}, {
    sort: 1,
    name: "YTD-Actual Vs. Budget <br /> 年累计-实际对比预算",
    fb: "",
    fb_prop: "",
    ac: "",
    covers: "",
    fb_profit: "",
    fb_payroll: "",
    fb_sales: "",
    fb_last: "",
    fb_vs: "",
    fb_prop_last: "",
    fb_prop_vs: "",
    ac_last: "",
    ac_vs: "",
    covers_last: "",
    covers_vs: "",
    fb_profit_last: "",
    fb_profit_vs: "",
    fb_payroll_last: "",
    fb_payroll_vs: "",
    fb_sales_last: "",
    fb_sales_vs: ""
}, {
    sort: 2,
    name: "MTD-Actual Vs. 2019 <br /> 月累计-实际对比2019",
    fb: "",
    fb_prop: "",
    ac: "",
    covers: "",
    fb_profit: "",
    fb_payroll: "",
    fb_sales: "",
    fb_last: "",
    fb_vs: "",
    fb_prop_last: "",
    fb_prop_vs: "",
    ac_last: "",
    ac_vs: "",
    covers_last: "",
    covers_vs: "",
    fb_profit_last: "",
    fb_profit_vs: "",
    fb_payroll_last: "",
    fb_payroll_vs: "",
    fb_sales_last: "",
    fb_sales_vs: ""
}, {
    sort: 3,
    name: "MTD-Actual Vs. Budget <br /> 月累计-实际对比预算",
    fb: "",
    fb_prop: "",
    ac: "",
    covers: "",
    fb_profit: "",
    fb_payroll: "",
    fb_sales: "",
    fb_last: "",
    fb_vs: "",
    fb_prop_last: "",
    fb_prop_vs: "",
    ac_last: "",
    ac_vs: "",
    covers_last: "",
    covers_vs: "",
    fb_profit_last: "",
    fb_profit_vs: "",
    fb_payroll_last: "",
    fb_payroll_vs: "",
    fb_sales_last: "",
    fb_sales_vs: ""
}];

export const data2 = [{
    sort: 0,
    rev: 0,
    mix: 0,
    ac: 0,
    cost: 0,
    covers: 0,
    brev: 0,
    vs: 0,
    bmix: 0,
    bvs: 0,
    bac: 0,
    bac_vs: 0,
    bcost: 0,
    bcost_vs: 0,
    bcovers: 0,
    bcovers_vs: 0,
    last_rev: 0,
    last_vs: 0,
    last_mix: 0,
    last_mix_vs: 0,
    last_ac: 0,
    last_ac_vs: 0,
    last_cost: 0,
    last_cost_vs: 0,
    last_covers: 0,
    last_covers_vs: 0
}, {
    sort: 1,
    rev: 0,
    mix: 0,
    ac: 0,
    cost: 0,
    covers: 0,
    brev: 0,
    vs: 0,
    bmix: 0,
    bvs: 0,
    bac: 0,
    bac_vs: 0,
    bcost: 0,
    bcost_vs: 0,
    bcovers: 0,
    bcovers_vs: 0,
    last_rev: 0,
    last_vs: 0,
    last_mix: 0,
    last_mix_vs: 0,
    last_ac: 0,
    last_ac_vs: 0,
    last_cost: 0,
    last_cost_vs: 0,
    last_covers: 0,
    last_covers_vs: 0
}, {
    sort: 2,
    rev: 0,
    mix: 0,
    ac: 0,
    cost: 0,
    covers: 0,
    brev: 0,
    vs: 0,
    bmix: 0,
    bvs: 0,
    bac: 0,
    bac_vs: 0,
    bcost: 0,
    bcost_vs: 0,
    bcovers: 0,
    bcovers_vs: 0,
    last_rev: 0,
    last_vs: 0,
    last_mix: 0,
    last_mix_vs: 0,
    last_ac: 0,
    last_ac_vs: 0,
    last_cost: 0,
    last_cost_vs: 0,
    last_covers: 0,
    last_covers_vs: 0
}, {
    sort: 3,
    rev: 0,
    mix: 0,
    ac: 0,
    cost: 0,
    covers: 0,
    brev: 0,
    vs: 0,
    bmix: 0,
    bvs: 0,
    bac: 0,
    bac_vs: 0,
    bcost: 0,
    bcost_vs: 0,
    bcovers: 0,
    bcovers_vs: 0,
    last_rev: 0,
    last_vs: 0,
    last_mix: 0,
    last_mix_vs: 0,
    last_ac: 0,
    last_ac_vs: 0,
    last_cost: 0,
    last_cost_vs: 0,
    last_covers: 0,
    last_covers_vs: 0
}];

export const data = [{
    sort: 0,
    name: "Budget餐饮预算",
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
    budget: 0,
    forecast: 0,
    actual: 0,
}, {
    sort: 1,
    name: "Forecast餐饮预测",
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
    budget: 0,
    forecast: 0,
    actual: 0,
}];


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/data.js